var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0a1 1 0 011 1v5h2c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2h-2v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-3H2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2V1a1 1 0 011-1zm-1 15H6v7h12v-7zm4-7H2v10h2v-4a1 1 0 011-1h14a1 1 0 011 1v4h2V8zm-4-6H6v4h12V2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconPrint;